import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReportsInitDataService {
  public dataInitialized = false;
}
